import * as bootstrap from "bootstrap";

export enum ModalType {
    INFO,
    CONFIRM,
    CUSTOM,
    FOOTLESS,
}

interface ModalOptionsBase {
    title?: string;
    content: string;
}

export interface ModalOptionsInfo extends ModalOptionsBase {
    type?: ModalType.INFO;
    confirmClb?: () => void;
}

export interface ModalOptionsFootless extends ModalOptionsBase {
    type: ModalType.FOOTLESS;
}

export interface ModalOptionsConfirm extends ModalOptionsBase {
    type: ModalType.CONFIRM;
    confirmClb?: () => void;
    denyClb?: () => void;
}

export interface ModalOptionsCustom extends ModalOptionsBase {
    type: ModalType.CUSTOM;
    options: {
        class?: string;
        text: string;
        clb: () => void;
    }[];
}

type ModalOptions = ModalOptionsInfo | ModalOptionsConfirm | ModalOptionsCustom | ModalOptionsFootless;

function createModal(opt: ModalOptions) {
    const $modal = document.createElement("div");
    $modal.classList.add("modal");

    let buttonHtml = "";
    if (typeof opt.type == "undefined" || opt.type == ModalType.INFO) {
        buttonHtml += `<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Zamknij</button>`;
    } else if (opt.type == ModalType.CONFIRM) {
        buttonHtml += `<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Anuluj</button>`;
        buttonHtml += `<button type="button" class="btn btn-primary" data-bs-dismiss="modal">Potwiedź</button>`;
    } else if (opt.type == ModalType.CUSTOM) {
        for (const entry of opt.options) {
            const cl = entry.class ?? "secondary";
            buttonHtml += `<button type="button" class="btn btn-${cl}" data-bs-dismiss="modal">${entry.text}</button>`;
        }
    }

    let footer = `<div class="modal-footer">${buttonHtml}</div>`;

    if (opt.type == ModalType.FOOTLESS) {
        footer = "";
    }

    $modal.innerHTML = `
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">${opt.title ?? "Uwaga"}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        ${opt.content}
      </div>
      ${footer}
    </div>
  </div>`;

    return $modal;
}

export function showModal(opt: ModalOptions): [bootstrap.Modal, HTMLElement] {
    const modal = createModal(opt);
    document.body.appendChild(modal);
    if (typeof opt.type == "undefined") {
        opt.type = ModalType.INFO;
    }

    const m = new bootstrap.Modal(modal, {
        backdrop: typeof opt.type == "undefined" || opt.type == ModalType.INFO ? true : "static",
    });

    if (opt.type == ModalType.INFO && opt.confirmClb) {
        modal.addEventListener("hide.bs.modal", opt.confirmClb);
    } else if (opt.type == ModalType.CONFIRM) {
        if (opt.denyClb) {
            modal.querySelector(".btn-close")?.addEventListener("click", opt.denyClb);
            modal.querySelector(".btn-secondary")?.addEventListener("click", opt.denyClb);
        }
        if (opt.confirmClb) {
            modal.querySelector(".btn-primary")?.addEventListener("click", opt.confirmClb);
        }
    } else if (opt.type == ModalType.CUSTOM) {
        let currBtt = modal.querySelector(".modal-footer")?.firstElementChild;
        for (const entry of opt.options) {
            currBtt?.addEventListener("click", entry.clb);
            currBtt = <Element>currBtt?.nextSibling;
        }
    }

    modal.addEventListener("hidden.bs.modal", () => {
        m.dispose();
        document.body.removeChild(modal);
    });
    m.show();
    (<HTMLButtonElement>modal.querySelector(".modal-footer button"))?.focus();
    return [m, modal];
}
